import { render, staticRenderFns } from "./TickerAdminViewEquity.vue?vue&type=template&id=8cb6b9f6&scoped=true"
import script from "./TickerAdminViewEquity.vue?vue&type=script&lang=js"
export * from "./TickerAdminViewEquity.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminViewEquity.vue?vue&type=style&index=0&id=8cb6b9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb6b9f6",
  null
  
)

export default component.exports